import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Button, HStack } from "native-base";
import { HomeIcon, EventsIcon, NetworkIcon, FavouriteIcon, HuddleDefaultIcon, HuddleActiveIcon } from "../../assets/icons/icon-assets";
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useWindowDimension } from '../../Utility/WindowDimensions';
import { SignalRService } from "../../AVCore/SignalR";
import { setIsConvoScreenOpen } from '../../Redux/Actions/userActions';
import { setFeedsScrollUpdate } from '../../Redux/Actions/feedsAction'

function Menu ( props : any )
{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [ isHome, setIsHome ] = React.useState( window.location.pathname === "/" );
    const [ isEvent, setIsEvent ] = React.useState( window.location.pathname === "/my-events" );
    const [ isTeams, setIsTeams ] = React.useState( window.location.pathname === "/my-teams" );
    const [ isFavourites, setIsFavourites ] = React.useState( window.location.pathname === "/favorites" );
    const [ isHuddles, setIsHuddles ] = React.useState( window.location.pathname.startsWith( "/huddles" ) );
    const currentUser = useSelector( ( state : RootStateOrAny ) => state.user.user[ 0 ] );
    const userconvo = useSelector( ( state : RootStateOrAny ) => state.convo.convo[ 0 ] );
    const dimensions = useWindowDimension();
    const isDesktopView = dimensions?.width <= 1200 || false;

    const [ isMounted, setIsMounted ] = React.useState( true ); // Flag to check if component is mounted

    // Cleanup function to set isMounted to false when the component unmounts
    React.useEffect( () =>
    {
        setIsMounted( true );
        return () => setIsMounted( false );
    }, [] );

    const handleNavigation = ( path : string, setState : React.Dispatch<React.SetStateAction<boolean>> ) =>
    {
        // Check if component is still mounted before updating state
        if ( !isMounted ) return;

        // Special handling for huddles navigation
        if ( path === '/huddles' )
        {
            // Get the first channel from user's orgs or use a default
            const channels = currentUser.orgs.filter( ( org ) => org.type === "Channel" ) ?? [];
            // Create a map of conversation lastUpdated times for quick lookup
            const convoUpdateMap = new Map(
                userconvo?.map( ( convo ) => [ convo.id, convo.lastUpdated ] ) ?? []
            );
            // Sort channels based on their corresponding conversation's lastUpdated
            const sortedChannels = channels.sort( ( a, b ) =>
            {
                const lastUpdatedA : any = convoUpdateMap.get( a.data ) || 0;
                const lastUpdatedB : any = convoUpdateMap.get( b.data ) || 0;
                // Convert to Date objects for comparison
                const dateA = new Date( lastUpdatedA );
                const dateB = new Date( lastUpdatedB );
                // Sort in descending order (most recent first)
                return dateB.getTime() - dateA.getTime();
            } );
            const defaultHuddle = sortedChannels[0] ?? [];
            //const defaultHuddle = currentUser?.orgs?.filter( x => x.type === "Channel" )?.reverse()[ 0 ];

            if ( defaultHuddle?.id )
            {
                navigate( `/huddles/${ defaultHuddle.id }` );
            } else
            {
                navigate( '/huddles/1' );
            }
        } else
        {
            navigate( path );
        }

        setIsHome( window.location.pathname === "/" ? true : false );
        setIsEvent( window.location.pathname === "/my-events" ? true : false );
        setIsTeams( window.location.pathname === "/my-teams" ? true : false );
        setIsFavourites( window.location.pathname === "/favorites" ? true : false );
        setIsHuddles( path === "/huddles" );
    };

    return (
        <HStack space={ '10' } justifyContent={ 'center' }>
            <Button
                borderRadius={ 'full' }
                paddingTop={ '10px' }
                paddingBottom={ '12px' }
                paddingLeft={ '11px' }
                disabled={ currentUser?.status === "NewUser" || currentUser?.status === "Deleted" }
                bgColor={ isDesktopView && isHome ? 'rgba(255,255,255,0.2)' : isHome ? '#00A7BC' : 'none' }
                _hover={ !isHome ? { bgColor: '#EEEEEE' } : { bgColor: '#00A7BC' } }
                //onPress={ () => { handleNavigation( '/', setIsHome ) } }
                onPress={ async () =>
                {
                    await SignalRService.lostFocus();
                    let setConvoScreenOpen = {
                        isOpen: false,
                        convoId: undefined,
                    };
                    dispatch( setIsConvoScreenOpen( setConvoScreenOpen ) );
                    if ( window.location.pathname === "/" )
                    {
                        dispatch( setFeedsScrollUpdate( true ) );
                    }
                    handleNavigation( '/', setIsHome )
                } }
            >
                <HomeIcon size={ '34px' } color={ isDesktopView ? 'white' : isHome ? 'white' : '#000' } />
            </Button>

            <Button
                borderRadius={ 'full' }
                paddingTop={ '10px' }
                paddingBottom={ '12px' }
                paddingLeft={ '11px' }
                disabled={ currentUser?.status === "NewUser" || currentUser?.status === "Deleted" }
                bgColor={ isDesktopView && isEvent ? 'rgba(255,255,255,0.2)' : isEvent ? '#00A7BC' : 'none' }
                _hover={ !isEvent ? { bgColor: '#EEEEEE' } : { bgColor: '#00A7BC' } }
                onPress={ async () =>
                {
                    await SignalRService.lostFocus();
                    let setConvoScreenOpen = {
                        isOpen: false,
                        convoId: undefined,
                    };
                    dispatch( setIsConvoScreenOpen( setConvoScreenOpen ) );
                    handleNavigation( '/my-events', setIsEvent )
                } }
            >
                <EventsIcon size={ '34px' } color={ isDesktopView ? 'white' : isEvent ? 'white' : '#000' } />
            </Button>

            <Button
                borderRadius={ 'full' }
                paddingTop={ '10px' }
                paddingBottom={ '12px' }
                paddingLeft={ '11px' }
                disabled={ currentUser?.status === "NewUser" || currentUser?.status === "Deleted" }
                bgColor={ isDesktopView && isTeams ? 'rgba(255,255,255,0.2)' : isTeams ? '#00A7BC' : 'none' }
                _hover={ !isTeams ? { bgColor: '#EEEEEE' } : { bgColor: '#00A7BC' } }
                onPress={ async () =>
                {
                    await SignalRService.lostFocus();
                    let setConvoScreenOpen = {
                        isOpen: false,
                        convoId: undefined,
                    };
                    dispatch( setIsConvoScreenOpen( setConvoScreenOpen ) );
                    handleNavigation( '/my-teams', setIsTeams )
                } }
            >
                <NetworkIcon height='34px' width='34px' color={ isDesktopView ? 'white' : isTeams ? 'white' : '#000' } stroke={ isDesktopView ? 'white' : isTeams ? 'white' : '#000' } strokeWidth={ isTeams ? '4px' : '4px' } />
            </Button>

            <Button
                borderRadius={ 'full' }
                paddingTop={ '10px' }
                paddingBottom={ '12px' }
                paddingLeft={ '11px' }
                disabled={ currentUser?.status === "NewUser" || currentUser?.status === "Deleted" }
                bgColor={ isDesktopView && isFavourites ? 'rgba(255,255,255,0.2)' : isFavourites ? '#00A7BC' : 'none' }
                _hover={ !isFavourites ? { bgColor: '#EEEEEE' } : { bgColor: '#00A7BC' } }
                onPress={ async () =>
                {
                    await SignalRService.lostFocus();
                    let setConvoScreenOpen = {
                        isOpen: false,
                        convoId: undefined,
                    };
                    dispatch( setIsConvoScreenOpen( setConvoScreenOpen ) );
                    handleNavigation( '/favorites', setIsFavourites )
                } }
            >
                <FavouriteIcon size={ '34px' } color={ isDesktopView ? 'white' : isFavourites ? 'white' : '#000' } />
            </Button>

            <Button
                borderRadius="full"
                paddingTop="10px"
                paddingBottom="12px"
                paddingLeft="11px"
                disabled={ currentUser?.status === "NewUser" || currentUser?.status === "Deleted" }
                bgColor={ isDesktopView && isHuddles ? 'rgba(255,255,255,0.2)' : isHuddles ? '#00A7BC' : 'none' }
                _hover={ {
                    bgColor: !isHuddles ? '#EEEEEE' : '#00A7BC',
                } }
                onPress={ async () =>
                {
                    handleNavigation( '/huddles', setIsHuddles );
                } }
            >
                { isDesktopView ?
                    <HuddleActiveIcon height="34px" width="34px" /> :
                    isHuddles ? (
                        <HuddleActiveIcon height="34px" width="34px" />
                    ) : (
                        <HuddleDefaultIcon height="34px" width="34px" />
                    ) }
            </Button>
        </HStack>
    );
}

export default React.memo( Menu );
